import { Link } from "react-router-dom";
import { Instagram, Mail, Twitter } from "lucide-react";

export default function Footer() {
  return (
    <footer className="bg-black text-white border-t-[3px] border-black">
      <div className="max-w-7xl mx-auto px-4 md:px-8 py-12 grid md:grid-cols-4 gap-10">
        <div>
          <div className="font-display text-2xl">UK PEPTIDE</div>
          <div className="font-display text-2xl text-[#ff1493]">RESEARCH</div>
          <p className="mt-4 text-xs font-mono-ui text-white/70 leading-relaxed">
            Research-grade peptides and laboratory supplies, dispatched from the United Kingdom.
          </p>
        </div>
        <div>
          <div className="font-mono-ui text-xs text-[#00d4ff] mb-4">SHOP</div>
          <ul className="space-y-2 text-sm">
            <li><Link to="/shop" className="hover:text-[#ff1493]">All products</Link></li>
            <li><Link to="/shop?category=Growth Peptides" className="hover:text-[#ff1493]">Growth peptides</Link></li>
            <li><Link to="/shop?category=Metabolic" className="hover:text-[#ff1493]">Metabolic</Link></li>
            <li><Link to="/shop?category=Lab Supplies" className="hover:text-[#ff1493]">Lab supplies</Link></li>
          </ul>
        </div>
        <div>
          <div className="font-mono-ui text-xs text-[#00d4ff] mb-4">COMPANY</div>
          <ul className="space-y-2 text-sm">
            <li><Link to="/about" className="hover:text-[#ff1493]">About</Link></li>
            <li><Link to="/research-use" className="hover:text-[#ff1493]">Research use only</Link></li>
            <li><Link to="/contact" className="hover:text-[#ff1493]">Contact</Link></li>
          </ul>
        </div>
        <div>
          <div className="font-mono-ui text-xs text-[#00d4ff] mb-4">CONNECT</div>
          <div className="flex items-center gap-3">
            <a href="mailto:hello@ukpeptideresearch.com" className="w-10 h-10 border-[3px] border-white flex items-center justify-center hover:bg-[#ff1493]"><Mail className="w-4 h-4" /></a>
            <a href="#" className="w-10 h-10 border-[3px] border-white flex items-center justify-center hover:bg-[#ff1493]"><Instagram className="w-4 h-4" /></a>
            <a href="#" className="w-10 h-10 border-[3px] border-white flex items-center justify-center hover:bg-[#ff1493]"><Twitter className="w-4 h-4" /></a>
          </div>
          <p className="mt-5 text-[11px] font-mono-ui text-white/50 leading-relaxed">
            Products listed are strictly intended for in-vitro laboratory research purposes and not for human or animal use.
          </p>
        </div>
      </div>
      <div className="border-t border-white/15">
        <div className="max-w-7xl mx-auto px-4 md:px-8 py-5 flex flex-col md:flex-row items-start md:items-center justify-between gap-3 text-[11px] font-mono-ui text-white/50">
          <div>© {new Date().getFullYear()} UK PEPTIDE RESEARCH LTD · ALL RIGHTS RESERVED</div>
          <div>MADE IN THE UK · SHIPPED FROM THE UK</div>
        </div>
      </div>
    </footer>
  );
}
